// Centralized camp label formatter so every dropdown / chip / breadcrumb
// shows the camp the same way the camp listing column renders it:
//   "{camp_name} [{camp_code}] (निरामय - {district})" when code + district are known
//   "{camp_name} [{camp_code}] (निरामय)" when only code is known
//   "{camp_name} (निरामय - {district})" when only district is known
//   "{camp_name} (निरामय)" otherwise
// camp_code is included to distinguish camps that share the same name.
// Pass any object that has at least camp_name; camp_code/district are optional.
export interface CampLike {
    camp_name?: string | null;
    camp_code?: string | null;
    district?: string | null;
}

export const formatCampLabel = (camp?: CampLike | null): string => {
    if (!camp) return '';
    const baseName = (camp.camp_name && camp.camp_name.trim()) || 'Unnamed Campaign';
    const withCode = camp.camp_code ? `${baseName} [${camp.camp_code}]` : baseName;
    return camp.district
        ? `${withCode} (निरामय - ${camp.district})`
        : `${withCode} (निरामय)`;
};
